export default {
  decimal: {
    style: "decimal",
    minimumFractionDigits: 1,
    maximumFractionDigits: 2
  }
};
